import CreatePlan from "@/Component/Admin/AdminPlan/CreatePlan"
import EditPlan from "@/Component/Admin/AdminPlan/EditPlan"

const AdminCreatePlanPage = () => {
  return (
    <EditPlan  />
  )
}

export default AdminCreatePlanPage
